import { gql } from '@apollo/client';
import type { MerchantsQuery, MerchantsQueryVariables, MerchantQuery } from '../generated';

export const MERCHANTS_QUERY = gql`
  query Merchants(
    $active: Boolean
    $search: String
    $sortField: String
    $sortOrder: String
    $page: Int
    $pageSize: Int
  ) {
    merchants(
      active: $active
      search: $search
      sortField: $sortField
      sortOrder: $sortOrder
      page: $page
      pageSize: $pageSize
    ) {
      edges {
        id
        name
        merchantCode
        active
        completedOrdersLast30Days
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        pageNumber
        totalPages
        totalCount
      }
    }
  }
`;

// Simple query for active merchants (used in sidebar)
export const ACTIVE_MERCHANTS_QUERY = gql`
  query ActiveMerchants {
    merchants(active: true, pageSize: 500) {
      edges {
        id
        name
        merchantCode
        active
      }
    }
  }
`;

export const MERCHANT_QUERY = gql`
  query Merchant($id: Int!) {
    merchant(id: $id) {
      id
      name
      merchantCode
      active
      accountManager
      logo
      street1
      street2
      city
      state
      zip
      phone
      website
      primaryEmail
      notes
      packaging
      brainConfig
      warehousePreference
      defaultShippingMethod
      labelGeneration
      productCountStandard
      productCountFoodService
      customPackagingInstructions
      overrideDefaultPackagingInstructions
      maxDryIceLbs
      orderProcessingQueueDelay
      precisionInventoryProcessing
      ignoreAdjustedTransitTime
      ignoreAdjustedTransitTimeWhenBypassing
      ignoreAdjustedTransitTimeAmazon
      fiveLbsIceReplacement
      fiveLbsIceBypass
      useStyrofoamForFoodService
      useStyrofoamForReplacements
      useStyrofoamForBypass
      shipsMondays
      shipsTuesdays
      shipsWednesdays
      shipsThursdays
      shipsFridays
      shipsAkAndHi
      daysBeforeCodeDateToExpire
      shipsFedex
      shipsFedexGroundEconomy
      shipsUps
      shipUpsSurepost
      shipsOntrac
      whiteLabel
      showWebsiteOnPacking
      showEmailOnPacking
      showPhoneOnPacking
      rerouteDryOrders
      allowGroundWeekendDelivery
      allowSaturdayExpressDelivery
      allowSaturdayExpressDeliveryPredefinedPackage
      hgApiShippingEndpoint
      hgApiAuthKey
      goldbellyToken
      upgradeToShipOptionStore
      upgradeToShipOptionSalesSample
      brainUpgradeStandardOos
      brainUpgradeStandardTransit
      brainUpgradeStandardHeat
      brainUpgradeStandardDelay
      brainUpgradeSamplesOos
      brainUpgradeSamplesTransit
      brainUpgradeSamplesHeat
      brainUpgradeSamplesDelay
      brainUpgradeAmazonDelay
    }
  }
`;

export type MerchantsResponse = MerchantsQuery;
export type MerchantFilters = MerchantsQueryVariables;
export type MerchantResponse = MerchantQuery;

export type MerchantListItem = NonNullable<NonNullable<NonNullable<MerchantsQuery['merchants']>['edges']>[number]>;
export type PageInfo = NonNullable<NonNullable<MerchantsQuery['merchants']>['pageInfo']>;
export type Merchant = NonNullable<MerchantQuery['merchant']>;
